var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"color":_vm.color,"indeterminate":_vm.indeterminate,"rotate":_vm.rotate,"size":_vm.size,"value":_vm.value,"width":_vm.width}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }